/** * NOTE: Snippet import in this file is required because slate-tool will build long name file ** */
import { initWebinarsHub } from '../../snippets/webinar-hub-page/webinar-hub-page';
import { WEBINAR_TYPES } from '../../scripts/config/constants';

initWebinarsHub(WEBINAR_TYPES.MULTIFAMILY);
